export interface NotFoundResponse {
  detail: string
}

export class NotFoundError extends Error {
  constructor({ detail: message }: NotFoundResponse) {
    super(message)
    this.name = 'NotFoundError'
  }
}
